import styled from 'styled-components';
import theme from 'theme/theme';
import media from 'utils/MediaQueries';
import {
	PAGE_MAX,
	PAGE_PAD,
	PAGE_PAD_MOBILE,
	Section,
	SectionInner,
	SectionBody,
	SectionHeader,
	SectionEyebrow,
	SectionTitle,
	SectionSubtitle,
	Grid,
	Item,
	ItemTitle,
	ItemText,
	PlatformNote,
} from 'components/Section/styled';

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const FeaturesWrapper = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	padding: 96px ${PAGE_PAD};
	margin-top: ${(props) => props.first && '40px'};

	${media.tablet`
		flex-direction: ${(props) => (props.reverse ? 'column-reverse' : 'column')};
		padding: 56px ${PAGE_PAD_MOBILE};
	`};

	${media.phone`
		flex-direction: ${(props) => (props.reverse ? 'column-reverse' : 'column')};
		padding: 56px ${PAGE_PAD_MOBILE};
		margin-top: ${(props) => props.first && '24px'};
	`};
`;

const Feature = styled.div`
	width: 100%;
	max-width: ${PAGE_MAX};
	display: flex;
	justify-content: space-between;
	align-items: center;

	${media.tablet`
		flex-direction: ${(props) => (props.reverse ? 'column-reverse' : 'column')};
	`};
`;

const Hero = styled.div`
	width: 100%;
	max-width: 1200px;
	display: flex;
	justify-content: space-between;
	margin-top: 120px;
	padding: 0 20px;

	${media.tablet`
		flex-direction: column;
		align-items: center;
		margin-top: 50px;
	`};

	${media.phone`
		margin-top: 0px;
	`};
`;

const CatalogueLink = styled.button`
	background: none;
	border: none;
	padding: 0;
	font: inherit;
	color: ${theme.primary1};
	cursor: pointer;
	text-decoration: underline;

	&:focus-visible {
		outline: 2px solid ${theme.primary1};
		outline-offset: 3px;
	}
`;

const FeatureImage = styled.img`
	width: 100%;
	max-width: 485px;

	${media.tablet`
		margin-top: 30px;
	`};
`;

const HeroImage = styled.img`
	width: 100%;
	max-width: 670px;
	margin-top: 30px;

	${media.tablet`
		margin-top: 70px;
	`};

	${media.phone`
		margin-top: 30px;
	`};
`;

const FeatureContent = styled.div`
	width: 100%;
	max-width: 400px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	${media.tablet`
		align-items: center;
	`};
`;

const FeatureDescription = styled.p`
	${media.tablet`
		text-align: center;
	`};
`;

const FeatureTitle = styled.h1`
	color: ${theme.primary1};
	font-size: 30px;

	${media.tablet`
		text-align: center;
	`};
`;


export {
	Wrapper,
	FeaturesWrapper,
	Feature,
	FeatureImage,
	FeatureDescription,
	FeatureTitle,
	FeatureContent,
	Hero,
	HeroImage,
	CatalogueLink,
	Section,
	SectionInner,
	SectionBody,
	SectionHeader,
	SectionEyebrow,
	SectionTitle,
	SectionSubtitle,
	Grid,
	Item,
	ItemTitle,
	ItemText,
	PlatformNote,
};
